module.exports = __webpack_public_path__ + "static/media/ru.5f85c630.svg";